import * as React from "react";
import { Progress as MantineProgress } from "@mantine/core";
const Root = React.forwardRef((props, ref) => /* @__PURE__ */ React.createElement(MantineProgress.Root, { ref, ...props }));
const Section = React.forwardRef((props, ref) => /* @__PURE__ */ React.createElement(MantineProgress.Section, { ref, ...props }));
const Label = ({ ...props }) => /* @__PURE__ */ React.createElement(MantineProgress.Label, { ...props });
const Progress = { Root, Section, Label };
export default Progress;
